import { render, staticRenderFns } from "./VES.vue?vue&type=template&id=2293d7c4&"
import script from "./VES.vue?vue&type=script&lang=js&"
export * from "./VES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports